import React from 'react';
import '../../App.css';
import AssessmentContent from '../AssessmentContent';

function Assessment() {
    return (
      <>
          <AssessmentContent />
      </>
    )
  }

export default Assessment;
